import { CloseOutlined } from "@ant-design/icons";
import { MapMarkerTabs } from "./Map-marker-tabs";
import { MapMarkerMiniMap } from "./Map-marker-mini-map";
import { Button, Tooltip } from "antd";
import { useContext } from "react";
import { NewFeatureListContext } from "./Map-marker-list-wrapper";
import { Point } from "ol/geom";

interface Props {
	onClose: () => void;
	onAdd: () => void;
}

export const MapMarkerNewForm = (props: Props) => {
	const { detour, selectedItem, isLoading } = useContext(NewFeatureListContext);

	const geom = selectedItem?.getGeometry();
	const isNull = !!geom && geom instanceof Point && geom.getCoordinates()[0] === 0;

	return (
		<section className="w-[618px] min-h-[362px] bg-white rounded-md shadow-md py-4 px-6 gap-4 flex flex-col justify-between">
			<header className="font-medium flex items-center justify-between">
				<h4>{detour ? "Apbraukšanas maršruta atrašanās vietas labošana" : "Atrašanās vietas labošana"}</h4>
				<button type="button" onClick={props.onClose}>
					<CloseOutlined />
				</button>
			</header>
			<MapMarkerTabs />
			<MapMarkerMiniMap />
			<div className="flex col-span-4 justify-end gap-2">
				<Button onClick={props.onClose}>Atcelt</Button>
				<Tooltip
					title={isNull ? "Nav norādīta atrašanās vieta" : ""}
					rootClassName="font-bold"
					color="#4d4f50"
					overlayInnerStyle={{ padding: ".25rem .75rem", borderRadius: ".25rem", textAlign: "center" }}
				>
					<Button onClick={props.onAdd} disabled={isNull || isLoading} type="primary">
						{selectedItem?.get("new") ? "Pievienot" : "Saglabāt"}
					</Button>
				</Tooltip>
			</div>
		</section>
	);
};
